import { render, staticRenderFns } from "./InsertPriceListProposal.vue?vue&type=template&id=2e911060"
import script from "./InsertPriceListProposal.vue?vue&type=script&lang=js"
export * from "./InsertPriceListProposal.vue?vue&type=script&lang=js"
import style0 from "./InsertPriceListProposal.vue?vue&type=style&index=0&id=2e911060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports